import React from 'react';
import { Popover, Button, Select, Icon, Checkbox } from 'antd';

const { Option } = Select;

export const ImageId = ({ onChange, ids = [], params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      <div style={{ marginBottom: 8 }}>
        <Checkbox
          onChange={(e) => {
            if (e.target.checked) {
              onChange({ ...params, value: ids });
            } else {
              onChange({ ...params, value: [] });
            }
          }}
          checked={ids.every((id) => (params?.value || []).includes(id))}
        >
          All
        </Checkbox>
      </div>
      <Select
        value={params?.value}
        mode='multiple'
        style={{ width: '150px' }}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().startsWith(input.toLowerCase())
        }
        onChange={(value) => {
          onChange({ ...params, value });
        }}
        allowClear
        placeholder='Image ID'
      >
        {ids.map((id) => (
          <Option key={id} value={id}>
            {id}
          </Option>
        ))}
      </Select>
    </>
  );

  return (
    <Popover content={content} title='Image Id' trigger='click'>
      <Button className='sighting-filter'>
        Image Id
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
